import { type RecommendationProductTypeContext } from '../../experiments/recommendation-attribution'
import { type CartIntermediateProductInfoSellerData } from '../components/CartIntermediateProductInfo/CartIntermediateProductInfoSellerLink/CartIntermediateProductInfoSellerLink'

import { type CartIntermediateEntryObject } from './CartIntermediateContextValue'

type CartIntermediateProduct = CartIntermediateEntryObject['product']

const getProductBrandName = (
  product: CartIntermediateProduct,
): string | undefined => {
  if (!product) {
    return undefined
  }

  let rootBrandName: string | undefined

  if ('brand' in product) {
    rootBrandName =
      typeof product.brand === 'string' ? product.brand : product.brand?.name
  }

  if (rootBrandName || !('variants' in product)) {
    return rootBrandName
  }

  return product.variants.find((variant) => variant.brand?.name)?.brand?.name
}

const getProductSellerId = (
  product: CartIntermediateProduct,
): string | undefined => {
  if (!product || !('seller_id' in product)) {
    return undefined
  }

  return product.seller_id
}

export const cartIntermediateAccessorGetProductTypeContext = ({
  product,
  sellerData,
}: {
  product: CartIntermediateProduct
  sellerData?: CartIntermediateProductInfoSellerData
}): RecommendationProductTypeContext => ({
  brandName: getProductBrandName(product),
  sellerId: sellerData?.sellerId ?? getProductSellerId(product),
})
